import { render, staticRenderFns } from "./InfoChatBot.vue?vue&type=template&id=6b477ce6&scoped=true"
import script from "./InfoChatBot.vue?vue&type=script&lang=js"
export * from "./InfoChatBot.vue?vue&type=script&lang=js"
import style0 from "./InfoChatBot.vue?vue&type=style&index=0&id=6b477ce6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b477ce6",
  null
  
)

export default component.exports